import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("button8", component(opts));
  editor.BlockManager.add("button8", block(opts));
};